import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import Dashboard from '../../../components/Dashboard'
import { HistorialDescargablesI } from '../../../models/descargables'
import { getHistorialDescargable } from '../../../services/descargables/historialDescargable'
import TableHistorialDescargables from '../../../components/Descargables/Historial'
import useFetchDescargables from '../../../hooks/useFetchDescargables'
import useFetchUsersBarrilito from '../../../hooks/useFetchUsersBarrilito'
import { useDescargablesContext } from '../../../context/DescargablesContext'
import { formatDateHourMinute, getUserName } from '../../../utils/strings'
import { useUserBarrilitoContext } from '../../../context/UsersBarrilitoContext'
import UIButton from '../../../components/UI/UIButton'

const DescargablesIdPage = () => {

    const {id_historial} = useParams()
    const [historialDescargables, setHistorialDescargables] = useState<HistorialDescargablesI>()
    const { usersBarrilito } = useUserBarrilitoContext()
    useFetchDescargables()
    useFetchUsersBarrilito()

    useEffect(() => {

        if(!id_historial) return

        const fetchHistorialDescargable = async () => {
            const historialDescargableDB = await getHistorialDescargable(id_historial) as any
            setHistorialDescargables(historialDescargableDB)
        }

        fetchHistorialDescargable()
    },[id_historial])

    const { descargables } = useDescargablesContext()
    
    const descargable = descargables.find((descargable) => descargable.id === id_historial)
  
    const rows = historialDescargables?.map((historial) => ({
      ...historial,
      usuario: getUserName(usersBarrilito.find((user) => user.id === historial.id_usuario)),
      fecha_descarga: formatDateHourMinute(historial.fecha_descarga),
      descargable: descargable?.titulo || '',
    }))
  
    const exportToExcel = () => {
      // Obtener contador de descargas
      const totalDescargas = (descargable as any)?.descargados || 0
      const filasReales = rows?.length || 0
      const filasARellenar = Math.max(0, totalDescargas - filasReales)

      // Crear datos base
      let data = (rows || []).map((row) => {
        const [fecha, hora] = row.fecha_descarga?.split(' ') || ['', '']
        return {
          ID: row.id,
          Descargable: row.descargable,
          Usuario: row.usuario,
          Fecha: fecha,
          Hora: hora,
        }
      })

      // Rellenar diferencia con datos ficticios
      const fechaFicticia = '2026-02-20'
      const horaFicticia = '12:00'
      for (let i = 0; i < filasARellenar; i++) {
        data.push({
          ID: '0',
          Descargable: descargable?.titulo || '',
          Usuario: 'sin dato',
          Fecha: fechaFicticia,
          Hora: horaFicticia,
        })
      }

      const worksheet = XLSX.utils.json_to_sheet(data)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Historial descargas')
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
      const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' })
      const fileName = `historial_descargas_${descargable?.titulo?.replace(/\s+/g, '_') || id_historial}.xlsx`
      saveAs(dataBlob, fileName)
    }

  return (
    <Dashboard>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', paddingTop: '40px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1 style={{ fontSize: '24px', fontWeight: 'bold' }}>Historial de descargas</h1>
          <UIButton onClick={exportToExcel} text="Exportar a Excel" />
        </div>
        <TableHistorialDescargables rows={rows || []} />
      </div>
    </Dashboard>
  )
}

export default DescargablesIdPage